// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DropDown__container-ca358e {
  width: var(--dropdown-width);
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 52px;
  background-color: var(--base-20);
  border-radius: 12px;
  box-sizing: border-box;
  padding-inline-end: 23px;
  padding-inline-start: 12px;
  cursor: pointer;
}

.DropDown__value-ffd5b5 {
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
  color: var(--base-110);
}

.DropDown__arrow-accbb3 {
  width: 10px;
  height: 6px;
  fill: var(--base-80);
}

.DropDown__helper-text-e4a918 {
  height: 16px;
  font: var(--font-caption-2);
  letter-spacing: var(--font-spacing-caption-2);
  color: var(--base-80);
  margin-top: 4px;
  padding: 0 12px;
}`, "",{"version":3,"sources":["webpack://./../../packages/components/src/form/DropDown/DropDown.styles.m.css"],"names":[],"mappings":"AAAA;EACE,4BAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;EACA,gCAAA;EACA,mBAAA;EACA,sBAAA;EACA,wBAAA;EACA,0BAAA;EACA,eAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;EACA,sBAAA;AACF;;AAEA;EACE,WAAA;EACA,WAAA;EACA,oBAAA;AACF;;AAEA;EACE,YAAA;EACA,2BAAA;EACA,6CAAA;EACA,qBAAA;EACA,eAAA;EACA,eAAA;AACF","sourcesContent":[".container {\n  width: var(--dropdown-width);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  height: 52px;\n  background-color: var(--base-20);\n  border-radius: 12px;\n  box-sizing: border-box;\n  padding-inline-end: 23px;\n  padding-inline-start: 12px;\n  cursor: pointer;\n}\n\n.value {\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n  color: var(--base-110);\n}\n\n.arrow {\n  width: 10px;\n  height: 6px;\n  fill: var(--base-80);\n}\n\n.helper-text {\n  height: 16px;\n  font: var(--font-caption-2);\n  letter-spacing: var(--font-spacing-caption-2);\n  color: var(--base-80);\n  margin-top: 4px;\n  padding: 0 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `DropDown__container-ca358e`,
	"value": `DropDown__value-ffd5b5`,
	"arrow": `DropDown__arrow-accbb3`,
	"helper-text": `DropDown__helper-text-e4a918`,
	"helperText": `DropDown__helper-text-e4a918`
};
module.exports = ___CSS_LOADER_EXPORT___;
